import { render, staticRenderFns } from "./ShopPickerDialog.vue?vue&type=template&id=096988f3&scoped=true&"
import script from "./ShopPickerDialog.vue?vue&type=script&lang=js&"
export * from "./ShopPickerDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShopPickerDialog.vue?vue&type=style&index=0&id=096988f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096988f3",
  null
  
)

component.options.__file = "ShopPickerDialog.vue"
export default component.exports